import '../styles/Siniestro.css'
import { Accordion, NavLink } from 'react-bootstrap';

const Siniestro = ({ siniestros, pasosSiniestros }) => {

    const tabs_perfil = (active) => {
        let items = document.querySelectorAll(".nav-perfil-links li.nav-item");
        let items_body = document.querySelectorAll(".tab-pane");

        if (active === "1") {
            items_body[0].classList.add("active");
            items_body[1].classList.remove("active");

            items[0].classList.add("item_activado");
            items[1].classList.remove("item_activado");
        } else if (active === "2") {
            items_body[0].classList.remove("active");
            items_body[1].classList.add("active");

            items[0].classList.remove("item_activado");
            items[1].classList.add("item_activado");
        }
    }

    return (
        <div className="container-fluid mw-1000" id="siniestro" style={{ 'scrollMarginTop': '80px' }}>
            <div className="container">
                <div className="homeout__coberturas">
                    <h2 className='color_azul mb-5'>¿Qué hacer si necesitas usar tu seguro?</h2>
                    {/* VERSION MOBILE */}
                    <div className="pt-5 pb-5 d-block d-lg-none">
                        <ul className="pt-3 px-5 list-group m-auto text-center" style={{ 'fontSize': '1.6rem', 'textAlign': 'left', 'maxWidth': '850px' }}>
                            <li className='list-pasitos-mov-num mt-2'>
                                1
                            </li>
                            <li className="list-group-item d-flex justify-content-between align-items-start border-0 list-pasitos-mov">
                                <div style={{ 'min-height': '80px' }} className='ms-2 me-auto p-2'>Acude a tu tienda Coppel de preferencia o llama al <a className='color_morado_light' href='tel:800 953 0424'>800 953 0424</a> de 09:00 a 21:00 horas cualquier día de la semana y cuéntanos qué pasó.</div>
                            </li>

                            <li className='list-pasitos-mov-num mt-2'>
                                2
                            </li>
                            <li className="list-group-item d-flex justify-content-between align-items-start border-0 list-pasitos-mov">
                                <div style={{ 'min-height': '80px' }} className='ms-2 me-auto p-2'>Posteriormente recibirás una llamada en la que te realizaremos <a className='color_morado_light'>algunas preguntas</a> para analizar tu solicitud y guiarte en los siguientes pasos.</div>
                            </li>

                            <li className='list-pasitos-mov-num mt-2'>
                                3
                            </li>
                            <li className="list-group-item d-flex justify-content-between align-items-start border-0 list-pasitos-mov">
                                <div style={{ 'min-height': '80px' }} className='ms-2 me-auto p-2'>Te enviaremos un link personal en donde podrás enviarnos la <a className='color_morado_light'>documentación requerida*</a> para continuar con tu solicitud.</div>
                            </li>
                        </ul>
                        <p className='footer__siniestro mt-5 px-5'>En caso de <span className='color_morado_light'>reemplazo</span> del equipo, te enviaremos una <span className='color_morado_light'>línea de captura</span> para realizar el pago del deducible (30% del precio de lista del equipo).</p>
                        <p className='footer__siniestro mt-5 px-5'>Si necesitamos que nos envíes tu equipo celular, recibirás instrucciones y una <span className='color_morado_light'>guía para envío</span> de tu equipo al Centro de Servicio Técnico Cardif.</p>
                        <div className='footer__siniestro divAviso homeout__coberturas mb-5'>
                            <div style={{'height':'150px'}}>
                            <img src="/assets/img/homeout/icono_aviso.svg" style={
                                {
                                    'float':'right',
                                    'position':'relative',
                                    'top':'-20px',
                                    'right':'15px'
                                }
                            }></img>
                            </div>
                            <p className='footer__siniestro mx-5'>
                                En todo momento te mantendremos informado sobre el estatus de tu solicitud y en un <a className='color_morado_light'>máximo de 7 días</a> podrás disfrutar de tu equipo nuevamente.
                            </p>
                        </div>
                        <p className='footer__siniestro mt-5 mb-5 px-5'>*Documentación requerida:</p>
                        <Accordion defaultActiveKey="0" flush>
                            {
                                siniestros && (
                                    siniestros.map((siniestro, index) => {
                                        let pasoFiltrados = pasosSiniestros.filter((ps) => ps.idTabSiniestro === siniestro.id)
                                        return (
                                            <Accordion.Item eventKey={String(index)}>
                                                <Accordion.Header><div className="header__accordion">{siniestro.tituloTab}</div></Accordion.Header>
                                                <Accordion.Body style={{ background: 'var(--gris-claro)' }}>
                                                    <div style={{ marginBottom: '4rem' }}>
                                                        {
                                                            (index === 0) ? 
                                                                <p className='desc__siniestro' style={{ paddingTop: '2rem', paddingBottom: '1rem' }}>Los siguientes documentos aplican para ambas coberturas:</p>
                                                            :   <p className='desc__siniestro' style={{ paddingTop: '2rem', paddingBottom: '1rem' }}>Documentos aplicables para la cobertura de Robo con violencia:</p>
                                                        }
                                                        <br/>
                                                        <ol className=" texto__siniestro list-group-numbered" style={{'paddingLeft':'0px !important'}}>
                                                            {
                                                                pasoFiltrados.map((paso, indexPaso) => {
                                                                    return (
                                                                        <li className="list-group-item d-flex justify-content-between align-items-start">
                                                                            <div className="ms-2 me-auto paso__siniestro">
                                                                                {paso.descripcionPaso}
                                                                            </div>
                                                                        </li>
                                                                    )
                                                                })
                                                            }
                                                        </ol>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        )
                                    })
                                )
                            }
                        </Accordion>
                    </div>

                    {/* VERSION DESKTOP */}
                    <div className="col-lg-7 d-none d-lg-block body__siniestro">
                        <table style={{width:'85%','margin':'auto'}} className='pt-3 m-auto'>
                            <tr>
                                <td><span className='list-pasitos-mov-num'>1</span></td>
                                <td style={{ 'fontSize': '1.6rem', 'textAlign': 'justify', 'maxWidth': '1000px' }}><div style={{ 'height': '80px','maxWidth':'90%','display':'inherit','verticalAlign':'middle'}} className='p-4 '>Acude a tu tienda Coppel de preferencia o llama al <a className='color_morado_light' href='tel:800 953 0424'>800 953 0424</a> de 09:00 a 21:00 horas cualquier día de la semana y cuéntanos qué pasó.</div></td>
                            </tr>
                            <tr>
                                <td><span className='list-pasitos-mov-num'>2</span></td>
                                <td style={{ 'fontSize': '1.6rem', 'textAlign': 'justify', 'maxWidth': '1000px' }}><div style={{ 'height': '80px','maxWidth':'90%','display':'inherit','verticalAlign':'middle'}} className='p-4 '>Posteriormente recibirás una llamada en la que te realizaremos <a className='color_morado_light'>algunas preguntas</a> para analizar tu solicitud y guiarte en los siguientes pasos.</div></td>
                            </tr>
                            <tr>
                                <td><span className='list-pasitos-mov-num'>3</span></td>
                                <td style={{ 'fontSize': '1.6rem', 'textAlign': 'justify', 'maxWidth': '1000px' }}><div style={{ 'height': '80px','maxWidth':'90%','display':'inherit','verticalAlign':'middle'}} className='p-4 '>Te enviaremos un link personal en donde podrás enviarnos la <a className='color_morado_light'>documentación requerida*</a> para continuar con tu solicitud.</div></td>
                            </tr>
                        </table>
                        <p className='footer__siniestro mt-5 text-start'>En caso de <span className='color_morado_light'>reemplazo</span> del equipo, te enviaremos una <span className='color_morado_light'>línea de captura</span> para realizar el pago del deducible (30% del precio de lista del equipo).</p>
                        <p className='footer__siniestro mt-5 text-start'>Si necesitamos que nos envíes tu equipo celular, recibirás instrucciones y una <span className='color_morado_light'>guía para envío</span> de tu equipo al Centro de Servicio Técnico Cardif.</p>
                        <div className='divAviso homeout__coberturas mb-5'>
                            <img src="/assets/img/homeout/icono_aviso.svg"></img>
                            <p className='footer__siniestro px-5' style={{'fontSize':'16px'}}>En todo momento te mantendremos informado sobre el estatus de tu solicitud y en un <a className='color_morado_light'>máximo de 7 días</a> podrás disfrutar de tu equipo nuevamente.</p>
                        </div>
                        
                        <p className='footer__siniestro mt-5 mb-5 text-start'>*Documentación requerida:</p>
                    <div>
                        <ul id="pr" className="nav nav-perfil-links">
                            {
                                siniestros && (
                                    siniestros.map((siniestro, index) => {
                                        return (
                                            <li index={index} className={(index === 0 ? "nav-item item_activado" : "nav-item")} onClick={() => tabs_perfil(`${siniestro.id}`)} >
                                                <div className="nav-link navSiniestro active" data-toggle="tab">
                                                    {siniestro.tituloTab}
                                                </div>
                                            </li>
                                        )
                                    })

                                )
                            }
                        </ul>
                    </div>

                    <div style={{ background: 'var(--gris-claro)' }}>
                        <div className="tab-content div-siniestro">
                            {
                                siniestros && (
                                    siniestros.map((siniestro, index) => {
                                        let pasoFiltrados = pasosSiniestros.filter((ps) => ps.idTabSiniestro === siniestro.id)
                                        return (
                                            <div className={index === 0 ? "tab-pane container active" : "tab-pane container"}>
                                                {
                                                    (index === 0) ? 
                                                        <p className='desc__siniestro'>Los siguientes documentos aplican para ambas coberturas:</p>
                                                    :   <p className='desc__siniestro'>Documentos aplicables para la cobertura de Robo con violencia:</p>
                                                }
                                                <br/>
                                                <ol className=" texto__siniestro list-group-numbered">
                                                    {
                                                        pasoFiltrados.map((paso, indexPaso) => {
                                                            return (
                                                                <li className="list-group-item d-flex justify-content-between align-items-start">
                                                                    <div className="ms-2 me-auto paso__siniestro">
                                                                        {paso.descripcionPaso}
                                                                    </div>
                                                                </li>
                                                            )
                                                        })
                                                    }
                                                </ol>
                                            </div>
                                        )
                                    })
                                )
                            }
                        </div>
                    </div>
                    
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Siniestro